import { AppBarProps, Layout as AdminLayout, LayoutProps } from "react-admin";

import { AppMenu } from "./components/AppMenu";
import { AppTopBar } from "./components/AppTopBar";
type LunaLayoutProps = Omit<LayoutProps, "menu" | "appBar"> &
  Pick<AppBarProps, "userMenu"> & {
    appNavigation: React.ReactNode;
  };

export const Layout = ({ appNavigation, userMenu, ...props }: LunaLayoutProps) => (
  <AdminLayout
    {...props}
    // toolbar has div inside to remove default refresh button from ra lib
    // SX is missing in type declarations
    // https://marmelab.com/react-admin/Layout.html#sx-css-api
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    appBar={() => (
      <AppTopBar userMenu={userMenu} toolbar={<div />}>
        {appNavigation}
      </AppTopBar>
    )}
    menu={AppMenu}
    sx={{
      "& .RaSidebar-paper": {
        display: "none"
      },
      "& .RaLayout-content": {
        display: "flex",
        alignItems: "center",
        marginTop: 1
      }
    }}
  />
);
